/**
 * Left-pads a string with the specified character until it reaches the desired length.
 *
 * @param value - The string or number to pad
 * @param length - Desired total length
 * @param padChar - The character to pad with (default: "0")
 * @returns The padded string
 */
export function lpad(value: string | number, length: number, padChar: string = "0"): string {
    const str = String(value);
    return str.length >= length ? str : padChar.repeat(length - str.length) + str;
}